import { render, staticRenderFns } from "./CustomerServiceQrList.vue?vue&type=template&id=33d68248&scoped=true"
import script from "./CustomerServiceQrList.vue?vue&type=script&lang=js"
export * from "./CustomerServiceQrList.vue?vue&type=script&lang=js"
import style0 from "./CustomerServiceQrList.vue?vue&type=style&index=0&id=33d68248&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d68248",
  null
  
)

export default component.exports